import MainLayout from "@/components/layout/MainLayout.vue";
import Pagination from "laravel-vue-pagination";
import StarRating from "vue-star-rating";
import moment from "moment";
import axios from "axios";
import TabCourseexplanation from "@/components/teacher/DetailCourseTab/TabCourseexplanation.vue";
import TabCoursedetail from "@/components/teacher/DetailCourseTab/TabCoursedetail.vue";
import TabTeacher from "@/components/teacher/DetailCourseTab/TabTeacher.vue";
import { mapGetters } from "vuex";
import store from "@/store";
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import CONFIG from '@/assets/js/config.js';

const convertNumberService = new ConvertNumService();

export default {
    name: "detailEnrollCourse",

    components: {
        MainLayout,
        Pagination,
        StarRating,
        TabCourseexplanation,
        TabCoursedetail,
        TabTeacher,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            courses: {
                course_id: "",
                course_title: "",
                course_explanation: "",
                course_details: "",
                certificate: "",
                update_time: "",
                name: "",
                teacher_id: "",
                rate: 0,
                experience: "",
                defaultPic: "",
                course_type: "",
                end_access_date: "",
            },
            courseStudent: {},
            end_access_date: '',
            classList: {},
            currentTab: "Courseexplanation",
            tabs: ["Courseexplanation", "Coursedetail", "Teacher"],
            lastPage: "",
            currentPage: ""
        };
    },

    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),

        currentTabComponent: function () {
            return "tab-" + this.currentTab.toLowerCase();
        },

        currentTabComponentProp: function () {
            if (this.currentTabComponent == "tab-coursedetail") {
                return {
                    course_detail: this.courses.course_details
                };
            }
            if (this.currentTabComponent == "tab-teacher") {
                return {
                    teacher_id: this.courses.teacher_id,
                    image: this.courses.profile,
                    name: this.courses.name,
                    school_name: this.courses.school_name,
                    teacher_detail: this.courses.message,
                    gender: this.courses.gender,
                    phone_number_1: this.courses.phone_number_1,
                    school_id: this.courses.school_id,
                    schools_name: this.courses.schools_name,
                    schools_phone_1: this.courses.schools_phone_1,
                    schools_profile: this.courses.schools_profile,
                    schools_message: this.courses.schools_message,
                    end_access_date: this.end_access_date,
                };
            }
            return {
                course_explanation: this.courses.course_explanation
            };
        }
    },

    methods: {
        getClassesByCourseId(page = 1) {
            axios.get("course/" + this.$route.params.id + "/class/list" + "?page=" + page)
                .then((response) => {
                    this.classList = response.data;
                    this.classList.total = convertNumberService.convertEng2Mm(this.classList.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.classList.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.classList.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Class List API error", error);
                });
        },

        getCourseDetail() {
            axios.get("course/" + this.$route.params.id)
                .then((response) => {
                    this.courses = response.data;
                    if (this.courses.course_type === CONFIG.COURSE_TYPE.VIDEO) {
                        this.getVideoCourseStudent();
                    }
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Course Detail API Error", error);
                });
        },

        getVideoCourseStudent() {
            axios.get("course/" + this.$route.params.id + "/enroll")
                .then((response) => {
                    this.end_access_date = response.data.enrollCourseStudent.end_access_date;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Course Detail API Error", error);
                });
        },

        notificationCount() {
            var id = null;
            var type = this.userType;
            if (this.teacherId) {
                id = this.teacherId;
            }
            if (this.studentId) {
                id = this.studentId;
            }
            axios.get("my/notification/count", {
                params: {
                    id: id,
                    type: type
                }
            })
                .then(response => {
                    store.commit("setNotificationCount", response.data);
                })
                .catch(error => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log(error, "error");
                });
        },
    },

    filters: {
        setMoment: function (date) {
            return moment(date).format("DD MMMM YYYY");
        },
    },

    mounted() {
        this.getClassesByCourseId();
        this.getCourseDetail();
        this.notificationCount();
    }
};
